import { useEffect, useRef } from 'react'

const useTimeout = (callback: () => void, delay: number | null) => {
  const savedCallback = useRef(callback)

  useEffect(() => {
    savedCallback.current = callback
  }, [callback])

  useEffect(() => {
    if (!delay && delay !== 0) {
      return
    }

    const timeOutId = setTimeout(() => savedCallback.current(), delay)

    return () => clearTimeout(timeOutId)
  }, [delay])
}

export default useTimeout
